module.exports = __webpack_public_path__ + "img/notifications/notification-prompt@2x-7fcca3af5ad20a2661c9c25c3c3483f0.png";